export default "__VITE_ASSET__GhJY108I__"